import { useContext, createContext, FC, ReactNode, useEffect } from "react";
import { useState } from "react";

interface CustomerMasterContextProps {
  confirmPassPopup: boolean;
  setConfirmPassPopup: (value: boolean) => void;
  constUserId: string;
  setconstUserId: (value: any) => void;
  userDetails: any[];
  setUserDetails: (value: any[]) => void;
  visible: boolean;
  setVisible: (value: boolean) => void;
  segmentPopUp: boolean;
  setSegmentPopUp: (value: boolean) => void;
  selectedStream: {}
  setselectedStream: (value: object) => void
  selectedChannel: {STREAM_CHANNEL_DESC? : string}
  setselectedChannel: (value: object) => void
  selectedSubChannel: {}
  setselectedSubChannel: (value: object) => void
  selectedSubSegmentDetail: {SEG_DESC? : string , SEG_CODE? : string , SBSD_ID? : string}
  setselectedSubSegmentDetail: (value: object) => void
  responsiveSideBar: boolean;
  setResponsiveSideBar: (Value:boolean)=>void;
  addtoFavmenuListData: [];
  setAddtoFavmenuListData: (Value:boolean)=>void;
}

const CustomerMasterContext = createContext<CustomerMasterContextProps>(
  {} as CustomerMasterContextProps
);

interface CustomerMasterProviderProps {
  children: ReactNode;
}

const CustomerMasterProvider: FC<CustomerMasterProviderProps> = ({
  children,
}) => {
  const [confirmPassPopup, setConfirmPassPopup] = useState(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [segmentPopUp, setSegmentPopUp] = useState<boolean>(false);
  const [constUserId, setconstUserId] = useState("");
  const [userDetails, setUserDetails] = useState<any[]>([]);
  const [selectedSubSegmentDetail, setselectedSubSegmentDetail] = useState({});
  const [selectedStream, setselectedStream] = useState({});
  const [selectedChannel, setselectedChannel] = useState({});
  const [selectedSubChannel, setselectedSubChannel] = useState<any | null>({});
  const [responsiveSideBar, setResponsiveSideBar] = useState<boolean>(false);
  const [addtoFavmenuListData, setAddtoFavmenuListData] = useState<any>([]);

  return (
    <CustomerMasterContext.Provider
      value={{
        confirmPassPopup,
        setConfirmPassPopup,
        constUserId,
        setconstUserId,
        userDetails,
        setUserDetails,
        setVisible,
        visible,
        segmentPopUp,
        setSegmentPopUp,
        selectedSubSegmentDetail,
        setselectedSubSegmentDetail,
        selectedStream, 
        setselectedStream,
        selectedChannel, 
        setselectedChannel,
        selectedSubChannel, 
        setselectedSubChannel,
        responsiveSideBar, 
        setResponsiveSideBar,
        addtoFavmenuListData,
        setAddtoFavmenuListData
      }}
    >
      {children}
    </CustomerMasterContext.Provider>
  );
};

export const useCustomerMasterContext = () => {
  return useContext(CustomerMasterContext);
};

export { CustomerMasterProvider, CustomerMasterContext };